import { useQuery } from '@tanstack/react-query';

import { INTERVIEW_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';
import { useStaffSession } from '@/hooks/auth';

const useConciergeSessions = (memberID: string, isEnabled: boolean = true) => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: INTERVIEW_KEYS.conciergeSessions(memberID),
    queryFn: async () => errorUtils.unwrap(await interviewsService.listConciergeSessions(memberID)),
    enabled: isEnabled && memberID.length > 0 && session?.stage === 'ready',
  });
};

export {
  useConciergeSessions,
};
